<template>
    <app-layout content_class="content-section has-background-light">
        <h1 class="title is-pulled-left">Admin Dashboard</h1>
        <user-avatar class="is-pulled-right"/>
        <div class="is-clearfix"></div><br/>
    </app-layout>
</template>

<script>
import AppLayout from '../components/layouts/AppLayout.vue';
import UserAvatar from '../components/user/UserAvatar.vue';

export default {
    name: 'AdminDashboard',
    components: { UserAvatar, AppLayout },
};
</script>
